
export default {
  props: {
    socialMedia: {
      type: Array,
      default: null
    }
  }
};
